// Tyre specification options derived from Metric_Tyre_Template.xlsx (Lists sheet)
export const VEHICLE_CLASSES = [
    { value: "P", label: "P — Passenger Car" },
    { value: "LT", label: "LT — Light Truck" },
    { value: "C", label: "C — Commercial" },
    { value: "ST", label: "ST — Special Trailer" },
    { value: "M/C", label: "M/C — Motorcycle" },
    { value: "T", label: "T — Truck" },
];

export const STANDARDS = [
    { value: "TRA", label: "TRA" },
    { value: "ETRTO", label: "ETRTO" },
];

export const CONSTRUCTION_TYPES = [
    { value: "R", label: "R (Radial)" },
    { value: "B", label: "B (Bias Belt)" },
    { value: "D", label: "D (Diagonal)" },
    { value: "Cross-ply", label: "Cross-ply" },
];

// Derive a canonical size string from the structured fields, e.g. 295/80R22.5.
// Returns null if any required field is missing.
export function deriveTyreSize({ section_width_mm, aspect_ratio, construction_type, rim_diameter_in }) {
    if (!section_width_mm || !construction_type || !rim_diameter_in) return null;
    const c = construction_type === "Cross-ply" ? "" : construction_type;
    if (aspect_ratio) {
        return `${section_width_mm}/${aspect_ratio}${c}${rim_diameter_in}`;
    }
    // No aspect ratio supplied (e.g. 11R22.5)
    return `${section_width_mm}${c}${rim_diameter_in}`;
}
